import get from 'lodash/get';
import Storage from 'shared/helpers/storage';
import { setCookie } from 'shared/helpers/utils';

const PIN_CODE_STORAGE_NAME = 'pincode';
const STORAGE_KEY_PINCODE = 'NFFE_PINCODE';
const PINCODE_COOKIE = 'pinCodeDel';

interface LocalPincodeInfo {
  pincode: string;
  pincodeResponseAvailable: boolean;
  response: Record<string, any>;
}

export const setPincodeToStorage = (pincode: string, setPinCodeCookie = false) => {
  Storage.setItem(PIN_CODE_STORAGE_NAME, pincode);
  if (setPinCodeCookie) {
    setCookie(PINCODE_COOKIE, pincode, 1);
  }
};

// in future we will move to single pincode field in the local storage
export const getPincodeFromStorage = (): string => {
  try {
    const pincodeNew = Storage.getItem(PIN_CODE_STORAGE_NAME) || '';
    const response = Storage.getItem(STORAGE_KEY_PINCODE) || '{}';
    const pincode = get(response, 'pincode', '');

    return pincodeNew !== '' ? pincodeNew : pincode;
  } catch (e) {
    return '';
  }
};

export const getPincodeInfo = (): LocalPincodeInfo => {
  try {
    const storedPincodeNew = Storage.getItem(PIN_CODE_STORAGE_NAME) || '';

    const response = Storage.getItem(STORAGE_KEY_PINCODE) || '{}';

    let pincodeResponseSaved;
    if (typeof response === 'string') {
      pincodeResponseSaved = JSON.parse(response);
    } else {
      pincodeResponseSaved = response;
    }
    const storedPincode = get(pincodeResponseSaved, 'pincode', '');

    const pincode = storedPincodeNew !== '' ? storedPincodeNew : storedPincode;
    let pincodeResponseAvailable = storedPincode !== '';

    if (storedPincodeNew !== '' && storedPincode !== '') {
      if (storedPincode !== storedPincodeNew) {
        pincodeResponseAvailable = false;
      }
    }

    return { pincode, pincodeResponseAvailable, response: pincodeResponseSaved.response };
  } catch (err) {
    return { pincode: '', pincodeResponseAvailable: false, response: {} };
  }
};
